import classNames from 'classnames';
import DocumentFolder from '../parts/DocumentFolder';

import styles from './documents-block.module.css';

const DocumentsBlock = ({ documents }) => {
  return (
    <div className={classNames(styles.root, 'grid grid-3')}>
      {documents.map((elem) => (
        <div key={elem.id}>
          <DocumentFolder
            title={elem.name}
            docs={elem.templates}
            idFolder={elem.id}
            {...elem}
          />
        </div>
      ))}
    </div>
  );
};

export default DocumentsBlock;
